import { useCallback, useState } from 'react';
import { DEFAULT_DETAIL_SORT_STATE } from './constants';
import { formatPriceValueHtml, getNextDetailSortState } from './SubstanceCommercialSupplierInfo.helpers';

export const EMPTY_OFFERS = [];

export const DETAIL_TABLE_COLUMNS = {
  availability: 'availabilityValue',
  packageSize: 'packageSize',
  price: 'price',
  purity: 'purityValue',
  selected: 'selected',
  shipmentCountry: 'shipmentCountryValue',
  shipping: 'shippingValue',
  supplier: 'supplierName',
};

export function useDetailSortState() {
  const [sortState, setSortState] = useState(DEFAULT_DETAIL_SORT_STATE);
  const handleSort = useCallback((field) => {
    setSortState((previousSortState) => getNextDetailSortState(previousSortState, field));
  }, []);

  return { sortState, handleSort };
}

export function getOfferStackItemKey(previewRowKey, offerIndex, cellType) {
  return `${previewRowKey}-${offerIndex}-${cellType}`;
}

export function getVisibleOfferStackItems(offers = []) {
  return offers.filter((offer) => Boolean(offer?.packageSize || formatPriceValueHtml(offer)));
}

export function getHeaderColumnClassName(columnValue) {
  if (columnValue === DETAIL_TABLE_COLUMNS.selected) return 'column-checkbox';
  if (columnValue === DETAIL_TABLE_COLUMNS.purity) return 'column-purity';
  if (columnValue === DETAIL_TABLE_COLUMNS.supplier) return 'column-supplier';

  return '';
}

export function buildNormalDetailTableColumns(columns, isProdSelectionEnabled) {
  const tableColumns = [];

  if (isProdSelectionEnabled) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.selected, label: '' });
  if (columns.showPurity) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.purity, label: 'Purity' });
  if (columns.showPackageSize) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.packageSize, label: 'Package size' });
  if (columns.showPrice) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.price, label: 'Price' });
  if (columns.showShipmentCountry) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.shipmentCountry, label: 'Shipment country' });
  if (columns.showShipping) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.shipping, label: 'Shipping Time' });
  if (columns.showAvailability) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.availability, label: 'Availability' });

  return tableColumns;
}

export function buildAggregatorDetailTableColumns(columns) {
  const tableColumns = [{ value: DETAIL_TABLE_COLUMNS.supplier, label: 'Supplier' }];

  if (columns.showPurity) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.purity, label: 'Purity' });
  if (columns.showPackageSize) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.packageSize, label: 'Package size' });
  if (columns.showPrice) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.price, label: 'Price' });
  if (columns.showShipmentCountry) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.shipmentCountry, label: 'Shipment country' });
  if (columns.showShipping) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.shipping, label: 'Shipping Time' });
  if (columns.showAvailability) tableColumns.push({ value: DETAIL_TABLE_COLUMNS.availability, label: 'Availability' });

  return tableColumns;
}

export function prepareDetailRowForLeydenTable(row) {
  return {
    ...row,
    packageSize: row.offers,
    price: row.offers,
    selected: row.offers,
  };
}
